const cdnUrl = 'https://cdn.bluenotion.nl';

export function resolveCdnUrl(filename: string, params?: any): string {
    let result = `${cdnUrl}/${filename}`;

    if (params) {
        let args = Object.keys(params)
            .map((k: string) => {
                return `${k}=${params[k]}`;
            })
            .reduce((a, b) => {
                if (a) {
                    return `${a}&${b}`;
                }

                return b;
            }, '');

        if (args.length > 0) {
            // auto-orient so resized images keep the correct (EXIF) orientation
            result += `?${args}&auto-orient`;
        }
    }

    return result;
}
